
import React from 'react';
import { Button } from '@/components/ui/button';
import { Trash2, Download } from 'lucide-react';

interface SelectionSummaryProps {
  selectedCount: number;
  totalCount: number;
  onDelete?: () => void;
  isDeleting?: boolean;
}

const SelectionSummary = ({ 
  selectedCount, 
  totalCount,
  onDelete,
  isDeleting
}: SelectionSummaryProps) => {
  if (selectedCount === 0) return null;
  
  return (
    <div className="sticky top-0 z-10 bg-white dark:bg-gray-900 border-b dark:border-gray-700 mb-4 py-3 px-4 flex items-center justify-between">
      <div className="flex items-center">
        <span className="font-medium dark:text-gray-200">
          {selectedCount} {selectedCount === 1 ? 'sélectionné' : 'sélectionnés'}
        </span>
      </div>
      <div className="flex items-center space-x-2">
        <Button 
          variant="outline" 
          size="sm"
          className="gap-2 dark:text-gray-300 dark:border-gray-700 dark:hover:bg-gray-800"
        >
          <Download className="h-4 w-4" />
          Exporter CSV
        </Button>
        {onDelete && (
          <Button 
            variant="destructive" 
            size="sm"
            onClick={onDelete}
            disabled={isDeleting}
            className="gap-2 dark:bg-red-700 dark:hover:bg-red-800"
          >
            <Trash2 className="h-4 w-4" />
            Supprimer
          </Button>
        )}
      </div>
    </div>
  );
};

export default SelectionSummary;
